import(/* webpackMode: "eager" */ "/workspace/dotheforgejo/oxpa-pro/src/app/(auth)/error.tsx");
